import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"
import { requireInventoryUserId } from "@/inventory/lib/auth.server"
import {
  createSupplyItem,
  getSupplyItem,
  listSupplyItems,
  updateSupplyItem,
} from "../lib/items.server"

const supplyItemFiltersSchema = z
  .object({
    categoryId: z.number().optional(),
    isActive: z.boolean().optional(),
    search: z.string().optional(),
    lowStockOnly: z.boolean().optional(),
    page: z.number().int().positive().optional(),
    pageSize: z.number().int().positive().optional(),
  })
  .optional()

export const listSupplyItemsFn = createServerFn({ method: "GET" })
  .validator((data?: unknown) => supplyItemFiltersSchema.parse(data ?? {}))
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return listSupplyItems(data ?? {})
  })

export const getSupplyItemFn = createServerFn({ method: "GET" })
  .validator((data: unknown) => z.object({ id: z.number() }).parse(data))
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return getSupplyItem(data.id)
  })

export const createSupplyItemFn = createServerFn({ method: "POST" })
  .validator((data: unknown) =>
    z
      .object({
        name: z.string(),
        sku: z.string().nullable().optional(),
        categoryId: z.number(),
        unit: z.string(),
        reorderLevel: z.number().int().nonnegative().nullable().optional(),
        unitCostCents: z.number().int().nonnegative().nullable().optional(),
        notes: z.string().nullable().optional(),
      })
      .parse(data),
  )
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return createSupplyItem(data)
  })

export const updateSupplyItemFn = createServerFn({ method: "POST" })
  .validator((data: unknown) =>
    z
      .object({
        id: z.number(),
        name: z.string().optional(),
        sku: z.string().nullable().optional(),
        categoryId: z.number().optional(),
        unit: z.string().optional(),
        reorderLevel: z.number().int().nonnegative().nullable().optional(),
        unitCostCents: z.number().int().nonnegative().nullable().optional(),
        notes: z.string().nullable().optional(),
        isActive: z.boolean().optional(),
      })
      .parse(data),
  )
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return updateSupplyItem(data)
  })
